import { ApplicationRef, DestroyRef, Injectable, inject } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { SwUpdate } from '@angular/service-worker';
import { filter, first, interval, startWith, switchMap } from 'rxjs';

const UPDATE_CHECK_INTERVAL_MS = 15 * 60 * 1000;

@Injectable({ providedIn: 'root' })
export class PwaUpdateService {
  private readonly applicationRef = inject(ApplicationRef);
  private readonly destroyRef = inject(DestroyRef);
  private readonly updates = inject(SwUpdate);
  private reloading = false;

  constructor() {
    this.updates.versionUpdates
      .pipe(
        filter((event) => event.type === 'VERSION_READY'),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.reloadForNewVersion());

    this.updates.unrecoverable
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => this.reloadForNewVersion());

    this.applicationRef.isStable
      .pipe(
        first((isStable) => isStable),
        switchMap(() => interval(UPDATE_CHECK_INTERVAL_MS).pipe(startWith(0))),
        takeUntilDestroyed(this.destroyRef),
      )
      .subscribe(() => this.checkForUpdate());
  }

  private checkForUpdate(): void {
    if (!this.updates.isEnabled) return;
    void this.updates.checkForUpdate().catch(() => undefined);
  }

  private reloadForNewVersion(): void {
    if (this.reloading) return;
    this.reloading = true;
    globalThis.location.reload();
  }
}
